import { render, staticRenderFns } from "./MovimientosManualesView.vue?vue&type=template&id=5830559d&scoped=true&lang=pug"
import script from "./MovimientosManualesView.vue?vue&type=script&lang=js"
export * from "./MovimientosManualesView.vue?vue&type=script&lang=js"
import style0 from "./MovimientosManualesView.vue?vue&type=style&index=0&id=5830559d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830559d",
  null
  
)

export default component.exports